/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dice_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll 2d6 for a board game — two dice, values 1–6.`)
};

const es_dice_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tira 2d6 para un juego de mesa — dos dados, valores del 1 al 6.`)
};

const de_dice_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Würfle 2d6 für ein Brettspiel — zwei Würfel mit Werten von 1–6.`)
};

const nl_dice_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gooi 2d6 voor een bordspel — twee dobbelstenen, waarden 1-6.`)
};

const fr_dice_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancez 2d6 pour un jeu de société — deux dés, valeurs de 1 à 6.`)
};

const it_dice_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancia 2d6 per un gioco da tavolo — due dadi, valori da 1 a 6.`)
};

const pt_br2_dice_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role 2d6 para um jogo de tabuleiro — dois dados, valores de 1 a 6.`)
};

const pt_dice_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lance 2d6 num jogo de tabuleiro — dois dados, valores de 1 a 6.`)
};

const ja_dice_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ボードゲームで2d6を振る — サイコロ2個、それぞれ1〜6の値。`)
};

const zh_dice_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`掷 2d6 进行桌游游戏——两个骰子，数值范围 1–6。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dice_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dice_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dice_ex1", locale)
	if (locale === "en") return en_dice_ex1(inputs)
	if (locale === "es") return es_dice_ex1(inputs)
	if (locale === "de") return de_dice_ex1(inputs)
	if (locale === "nl") return nl_dice_ex1(inputs)
	if (locale === "fr") return fr_dice_ex1(inputs)
	if (locale === "it") return it_dice_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_dice_ex1(inputs)
	if (locale === "pt") return pt_dice_ex1(inputs)
	if (locale === "ja") return ja_dice_ex1(inputs)
	return zh_dice_ex1(inputs)
};